const category = {
  pageTitle: '全品类特惠专区',
  pageDescription: '浏览岛国精品全部分类商品，涵盖美妆护肤、食品零食、家居日用、健康保健等多品类日本原装进口好物。',
  allCategories: '全部',
  tabBeauty: '美妆护肤',
  tabFood: '食品零食',
  tabHome: '家居日用',
  tabHealth: '健康保健',
  tabFashion: '服饰配饰',
  tabBaby: '母婴用品',
  tabDigital: '数码电器',
  productCount: '件商品',
  emptyProducts: '该分类暂无商品，请浏览其他分类',
  filterLabel: '筛选',
  sortLabel: '排序',
  sortNewest: '最新上架',
  sortPopular: '最受欢迎',
  sortPriceLow: '价格从低到高',
  sortPriceHigh: '价格从高到低',
};

export default category;